import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsOverview = ({ stats }) => {
  const statCards = [
    {
      label: 'Total Users',
      value: stats?.totalUsers || 0,
      icon: 'Users',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'Active Users',
      value: stats?.activeUsers || 0,
      icon: 'UserCheck',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      label: 'Administrators',
      value: stats?.administrators || 0,
      icon: 'Shield',
      color: 'text-error',
      bgColor: 'bg-error/10'
    },
    {
      label: 'Managers',
      value: stats?.managers || 0,
      icon: 'Award',
      color: 'text-warning-foreground',
      bgColor: 'bg-warning/10'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-16 md:gap-24 mb-32 md:mb-40">
      {statCards?.map((stat, index) => (
        <div
          key={index}
          className="bg-card rounded-lg shadow-elevation-2 border border-border p-20 md:p-24"
        >
          <div className="flex items-center justify-between mb-12">
            <div className={`w-[44px] h-[44px] rounded-lg ${stat?.bgColor} flex items-center justify-center`}>
              <Icon name={stat?.icon} size={20} color={`var(--color-${stat?.color?.replace('text-', '')})`} />
            </div>
          </div>
          <div>
            <p className="text-2xl md:text-3xl font-bold text-foreground mb-4">{stat?.value}</p>
            <p className="text-sm text-muted-foreground">{stat?.label}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsOverview;